import {
  FETCH_POSITIONS_REQUEST,
  FETCH_POSITIONS_SUCCESS,
  FETCH_POSITIONS_FAILURE,
  ADD_POSITION_REQUEST,
  ADD_POSITION_SUCCESS,
  ADD_POSITION_FAILURE,
  UPDATE_POSITION_REQUEST,
  UPDATE_POSITION_SUCCESS,
  UPDATE_POSITION_FAILURE,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_FAILURE,
  FETCH_POSITION_SUCCESS,
  CLEAR_POSITION_VALUES,
} from "./actionType";
import { PositionType } from "../../core/entities/position";
import { initiateRequest } from "../request/action";

export const fetchPositions = (
  limit?: number,
  where?: [string, "<" | "<=" | "==" | ">=" | ">", string | number | boolean][]
) =>
  initiateRequest({
    type: FETCH_POSITIONS_REQUEST,
    payload: { where, limit },
  });

export const fetchPositionSuccess = (positions: PositionType[]) => ({
  type: FETCH_POSITIONS_SUCCESS,
  payload: { positions },
});

export const fetchPositionsFailure = (error: string) => ({
  type: FETCH_POSITIONS_FAILURE,
  payload: { error },
});

export const addPositionRequest = (position: PositionType) =>
  initiateRequest({
    type: ADD_POSITION_REQUEST,
    payload: { position },
  });

export const addPositionSuccess = () => ({
  type: ADD_POSITION_SUCCESS,
});

export const addPositionFailure = (error: string) => ({
  type: ADD_POSITION_FAILURE,
  payload: { error },
});

export const clearPositionValues = () => ({
  type: CLEAR_POSITION_VALUES,
});

export const fetchPosition = (id: string) =>
  initiateRequest({
    type: FETCH_POSITION_REQUEST,
    payload: { id },
  });

export const fetchPositionByIdSuccess = (position: Partial<PositionType>) => ({
  type: FETCH_POSITION_SUCCESS,
  payload: { position },
});

export const fetchPositionFailure = () => ({
  type: FETCH_POSITION_FAILURE,
});

export const updatePosition = (id: string, data: Partial<PositionType>) => ({
  type: UPDATE_POSITION_REQUEST,
  payload: { id, data },
});

export const updatePositionSuccess = () => ({
  type: UPDATE_POSITION_SUCCESS,
});

export const updatePositionFailure = (error: string) => ({
  type: UPDATE_POSITION_FAILURE,
  payload: { error },
});
